export default function projectFeed() {
  return {
    _id: false,
    type: 'droplet.projectFeed',
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
    sort: 'newest',
    sortKey: false,
    filters: [],
    match: 'all',
    itemCount: 3,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/project-feed/droplet.schema.js